import { useEffect, useState } from 'react';
import { getBranchReceipts } from '../services';
import { IBranchReceiptsData, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

/**
 * Resumen de recibos sin depositar de la caja de una sucursal.
 * Solo nos interesan los totales → pedimos limit=1.
 */
export function useBranchReceipts(options?: { branch?: string }): HookState<IBranchReceiptsData> {
	const [state, setState] = useState<HookState<IBranchReceiptsData>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const branch = options?.branch;

	useEffect(() => {
		if (!branch) {
			setState({ data: null, loading: false, error: null, cachedAt: null });
			return;
		}

		let cancelled = false;
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getBranchReceipts({ branch, limit: 1, offset: 0 })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled) setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
		};
	}, [branch]);

	return state;
}
